import Container from "../Container";
import SingleCrousel from "../Crousel";
import SearchBar from "../searchBar/searchBar";
import AdvancedSearch from "../searchBar/AdvancedSearch";
import "./homePage.scss";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  const heroData = [
    {
      key: 1,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "9000000",
      imgUrl: "/h1.jpg",
    },
    {
      key: 2,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "1000000",
      imgUrl: "/h2.jpg",
    },
    {
      key: 3,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "6000000",
      imgUrl: "/h3.jpg",
    },
  ];

  const handleSearch = (query) => {
  //  console.log("query___eeeee",query);
    navigate('/Property', { state: { query } });
  };

const handleAdvanceSearch = (data) => {
  console.log("Advanced Search Data:", data);
    // Navigate to /Property with state
    navigate('/Property', { state: { data } });
  };
return (
  <section className="heroBanner">
    {/* Background slider */}
    <div className="heroBannerBg">
      <SingleCrousel data={heroData} />
      <div className="heroOverlay" />
    </div>

    {/* Content overlay */}
    <div className="heroContentWrap">
      <div className="heroSearchBox">
        <AdvancedSearch
          propertyTypes={[
            "Apartments",
            "Villas",
            "Plots",
            "Row Houses",
            "Villaments",
            "Commercial Properties",
            "Pent Houses",
          ]}
          budgets={[5, 10, 20, 30, 40, 50, 75, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000]}
          onSearch={handleAdvanceSearch}
        />
      </div>

      {/* Bottom Text */}
      <div className="heroText">
        <h1>
          Find Your <span>Dream Property</span>
        </h1>
        <p>
          Discover verified premium homes, villas, plots & commercial properties
          at the best price.
        </p>
      </div>
    </div>
  </section>
);



   
}

export default HomePage;
